<template>
  <section>
    <!--    <bi-channel-date-search @change="fetchData" type="month"></bi-channel-date-search>-->
    <div class="bi-channel-date-search">
      <el-form :inline="true">
        <el-form-item>
          <channel-cascade :multiple="true"></channel-cascade>
        </el-form-item>
        <el-form-item>
          <server-multiple-select @serverList="getServerList"></server-multiple-select>
        </el-form-item>
        <el-form-item>
          <el-form :inline="true">
            <el-form-item>
              <el-date-picker
                ref="startTimePicker"
                :clearable = false
                :editable = false
                v-model="timeValue[0]"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>-</el-form-item>
            <el-form-item>
              <el-date-picker
                ref="endTimePicker"
                :clearable = false
                :editable = false
                v-model="timeValue[1]"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData" :loading="loading">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(td, tab) in tabs" :label="td.label" :name="tab" :key="tab"></el-tab-pane>
        <el-table
          :data="tableData" style="width: 100%"
          stripe sortable
          :max-height="clientHeight"
          show-summary :summary-method="getSummaries"
          v-loading="loading"
          element-loading-text="拼命加载中,请稍等..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          >
          <el-table-column
            :prop="item.value"
             :label="item.label"
             v-for="item in tableHeaderList"
             :fixed="item.value === 'date' || item.value === 'channel'"
             :key="item.value"
             :sortable="item.sortable"
             :formatter="item.formatter ? autoFormatter : null"></el-table-column>
        </el-table>
      </el-tabs>
      <export-excel style="margin: 10px" v-show="exportExcelVisible" :data="exportData" :headers="tableHeaderList" :filename="tabs[activeName].excelFilename"></export-excel>
    </div>
  </section>
</template>

<script>
import api from '@/api/bi'
import option from '@/common/option'
import ExportExcel from '@/components/Excel/ExportExcel'
import ChannelCascade from '@/components/Channel/ChannelCascade'
import ServerMultipleSelect from '@/components/Server/ServerMultipleSelect'
import f from '@/filter'
export default {
  components: {
    ExportExcel,
    ChannelCascade,
    ServerMultipleSelect
  },
  computed: {
    // tables () {
    //   return this.tableData.slice(0, this.rangeYNumber)
    // },
    // tHeaderList () {
    //   return this.tableHeaderList.slice(0, this.rangeXNumber)
    // },
    clientHeight () {
      return document.body.clientHeight * 0.8
    }
  },
  data () {
    let thDate = { value: 'date', label: '日期', sortable: true, formatter: true }
    let thChannel = { value: 'channel', label: '渠道', sortable: true, formatter: true }
    let thServer = { value: 'server', label: '服务器', sortable: true, formatter: true }
    let thList = [
      { value: 'loginDeviceAdd', label: '新增设备' },
      { value: 'loginUserAdd', label: '新增用户', sortable: true },
      { value: 'loginUser', label: '活跃用户', sortable: true },
      { value: 'loginUserOld', label: '老用户' },
      { value: 'payMoney', label: '付费金额', sortable: true },
      { value: 'payUser', label: '付费用户', sortable: true },
      { value: 'payRate', label: '付费率(%)', sortable: true },
      { value: 'arppu', label: 'ARPPU' },
      { value: 'arpu', label: 'ARPU' },
      { value: 'payMoneyAdd', label: '新增付费金额' },
      { value: 'payUserAdd', label: '新增付费用户' },
      { value: 'payUserOld', label: '老付费用户' },
      { value: 'payRateAdd', label: '新增付费率' },
      { value: 'arppuAdd', label: '新增ARPPU' },
      { value: 'arpuAdd', label: '新增ARPU' },
      { value: 'arpuOld', label: '老用户ARPU' },
      { value: 'payRateOld', label: '老用户付费率' },
      { value: 'arppuOld', label: '老用户ARPPU' },
      { value: 'keep2', label: '次日留存' },
      { value: 'keep3', label: '3日留存' },
      { value: 'keep4', label: '4日留存' },
      { value: 'keep5', label: '5日留存' },
      { value: 'keep6', label: '6日留存' },
      { value: 'keep7', label: '7日留存' },
      { value: 'keep14', label: '14日留存' },
      { value: 'keep30', label: '30日留存' },
      { value: 'keep45', label: '45日留存' },
      { value: 'keep60', label: '60日留存' },
      { value: 'keep90', label: '90日留存' },
      { value: 'keep120', label: '120日留存' },
      { value: 'keep180', label: '180日留存' },
      { value: 'ltv1', label: '当日ltv' },
      { value: 'ltv2', label: '次日ltv' },
      { value: 'ltv3', label: '3日ltv' },
      { value: 'ltv4', label: '4日ltv' },
      { value: 'ltv5', label: '5日ltv' },
      { value: 'ltv6', label: '6日ltv' },
      { value: 'ltv7', label: '7日ltv' },
      { value: 'ltv14', label: '14日ltv' },
      { value: 'ltv30', label: '30日ltv' },
      { value: 'ltv45', label: '45日ltv' },
      { value: 'ltv60', label: '60日ltv' },
      { value: 'ltv90', label: '90日ltv' },
      { value: 'ltv120', label: '120日ltv' },
      { value: 'ltv180', label: '180日ltv' },
      { value: 'loginUserAverage', label: '日均活跃用户' },
      { value: 'payUserAverage', label: '日均付费用户' }
    ]
    let startTime = this.$moment().add(-3, 'month').format('YYYY-MM')
    let endTime = this.$moment().format('YYYY-MM')
    return {
      timeValue: [startTime, endTime],
      serverList: [],
      loading: false,
      thList: thList,
      activeName: 'tab1',
      tableData: [],
      tabs: {
        tab1: { label: '数据总览', apiFunc: api.getReportMonthlyServerDate, thExtends: [thDate], excelFilename: '分服月报-总览' },
        tab2: { label: '渠道数据', apiFunc: api.getReportMonthlyServerChannel, thExtends: [thChannel], excelFilename: '分服月报-渠道' },
        tab3: { label: '分服数据', apiFunc: api.getReportMonthlyServer, thExtends: [thServer], excelFilename: '分服月报-分服' },
        tab4: { label: '原始数据', apiFunc: api.getReportMonthlyServerOrigin, thExtends: [thDate, thChannel, thServer], excelFilename: '分服月报-原始' }
      },
      tabMap: new Map(),
      sumMap: new Map(),
      option: option,
      tableHeaderList: [],
      exportExcelVisible: false,
      exportData: []
      // rangeXNumber: 60,
      // rangeYNumber: 30
    }
  },
  created () {
    // this.handleClick()
  },
  methods: {
    fetchData () {
      // this.tabMap.clear()
      this.fetchTabData()
    },
    fetchTabData () {
      this.loading = true
      this.changeTableHeaders()
      let params = { st: this.timeValue[0], et: this.timeValue[1], servers: [] }
      for (let s of this.serverList) {
        params.servers.push(s)
      }
      this.tabs[this.activeName].apiFunc(params).then(res => {
        this.loading = false
        this.tableData = res.data
        this.tabMap.set(this.activeName, res.data)
        this.sumMap.set(this.activeName, res.sum)
        this.handleExportShow()
      })
    },
    getServerList (serverList) {
      this.serverList = serverList
    },
    changeTableHeaders () {
      this.exportExcelVisible = false
      this.tableData = []
      let tab = this.tabs[this.activeName]
      this.tableHeaderList = [...tab.thExtends, ...this.thList]
    },
    handleClick () {
      this.changeTableHeaders()
      if (this.tabMap.has(this.activeName)) {
        this.tableData = this.tabMap.get(this.activeName)
        this.handleExportShow()
      }
      // } else {
      //   this.fetchTabData()
      // }
    },
    handleExportShow () {
      let sumData = this.sumMap.get(this.activeName)
      let sum = Object.assign({ date: '统计', channel: '统计' }, sumData)
      this.exportData = [...this.tableData]
      this.exportData.push(sum)
      this.exportExcelVisible = true
    },
    getSummaries (param) {
      const { columns } = param
      const sums = []
      let sumData = this.sumMap.get(this.activeName)
      if (!sumData) {
        return sums
      }
      columns.forEach((column, index) => {
        let key = column.property
        if (index === 0) {
          sums[index] = '统计'
          return
        }
        sums[index] = sumData[key]
      })
      return sums
    },
    autoFormatter (row, column, cellValue) {
      return f.autoFormat(column.property, cellValue)
    }
    // loadMore (str) {
    //   if (!str) {
    //     this.rangeYNumber = this.tableData.length
    //   }
    //   if (str === 'x') {
    //     this.rangeXNumber += 5
    //   }
    //   if (str === 'y') {
    //     this.rangeYNumber += 10
    //   }
    // }
  }
}
</script>
